<template>
    <header role="banner" class="header">
        <div class="container position-relative">
            <div class="logo">
                <router-link to="/">
                    <img
                        src="/static/img/logo-rockstars.png"
                        alt="Rockstars IT"
                        class="logo-image"
                    />
                </router-link>
            </div>
            <MainNav />
        </div>
    </header>
</template>

<script>
import MainNav from '@/components/MainNav';

export default {
    name: 'RockHeader',
    components: {
        MainNav
    },
    data() {
        return {
            userInfo: []
        };
    },
    mounted: function () {
        this.$keycloak.getUserInfo().then((response) => {
            this.userInfo = response;
        });
    }
};
</script>
